export enum REQUEST_URLS {
    assetclass_filter = '/fundmaster/assetclasses',
    industry_filter = 'stockmaster/industrysubindustrydata',
    dashboard_asset_data = '/dashboard/getassetclassdata',
    explore_industries = '/stockmaster/stockindustrydata',
    explore_industries_map = '/stockmaster/stockindustrydataformap',
    explore_industries_id= '/stockmaster/stockindustrydata',
    explore_stocks_table = '/stockmaster/stocklistbyfilter',
    explore_stocks_table_updowngrade = '/stockmaster/stocklistbyupgradedowngrade',
    explore_stocks_map = '/stockmaster/countrycoveragebyfilter',
    explore_stocks_map_updowngrade = '/stockmaster/countrycoveragebyupgradedowngrade',
    explore_funds_table = '/fundmaster/fundslistbyfilter',
    explore_funds_table_updowngrade = '/fundmaster/fundslistbyupgradedowngrade',
    explore_funds_map = '/fundmaster/fundsregionwisedata',
    explore_funds_map_updowngrade = '/fundmaster/fundsregionwiseupgradedowngradedata',
    explore_markets_table = '/stockmaster/stockmarketdatagridlist',
    explore_markets_map = '/stockmaster/stockmarketdata',
    // explore_funds_map = '/fundmaster/fundregioncoverage',
    explore_stocks_pdf = '/download/stock',
    explore_funds_pdf = '/download/fund',
    terms_conditions = '/account/terms',
    policy_conditions = '/account/privacy',
    dashboard_market_pdf = '/download/marketbylevel',
    dashboard_market_circle_pdf = '/download/market',
    get_all_glossary = '/glossary/get/all',
    watchlist_alerts = '/watchlist/getwatchlistalert',
    clear_alerts_list = '/watchlist/clearallalert',
    explore_watchlist_pdf = '/download/watchlist',
    download_watch_list_deatils = '/watchlist/downloadwatchlistdeatils',
    publish_date ='/publishdate/getpublishdate/STOCK_DATA',
    //get country dashboard
    dashboard_country= '/dashboard/getCountryList',
    dashboard_getStockMarket = '/dashboard/getStockMarketData',
    downloadTemplate = '/watchlist/downloadtemplate/watchlist',
    uploadwatchlistmaster = '/watchlist/uploadwatchlistmaster/',
    downloadConsolidated = '/watchlist/downloadwatchlistdeatils/consolidated',
    downloadConsolidatedAnalysisReport = '/download/analysisreport/consolidated',
    useractivitylogs = '/logs/useractivitylogs',
    registrationlogs = '/logs/registrationlogs',
}